import { createSlice } from '@reduxjs/toolkit';


export const stateSlice = createSlice({
  name: 'compatibility-short',
  initialState: {
    name: "",
    birthDate: {},
    birthPlace: "",
    birthTime: {},
    gender: "",
    partnerName: "",
    partnerBirthDate: {},
    partnerBirthPlace: "",
    partnerBirthTime: {},
  },
  reducers: {
    setName: (state, action) => {
      state.name = action.payload
    },
    setBirthDate: (state, action) => {
      state.birthDate = action.payload
    },
    setBirthPlace: (state, action) => {
      state.birthPlace = action.payload
    },
    setBirthTime: (state, action) => {
      state.birthTime = action.payload
    },
    setGender: (state, action) => {
      state.gender = action.payload
    },
    setPartnerName: (state, action) => {
      state.partnerName = action.payload
    },
    setPartnerBirthDate: (state, action) => {
      state.partnerBirthDate = action.payload
    },
    setPartnerBirthPlace: (state, action) => {
      state.partnerBirthPlace = action.payload
    },
    setPartnerBirthTime: (state, action) => {
      state.partnerBirthTime = action.payload
    },
  }
})

export const { setName, setBirthDate, setBirthPlace, setBirthTime, setGender, setPartnerName, setPartnerBirthDate, setPartnerBirthPlace, setPartnerBirthTime } = stateSlice.actions

export default stateSlice.reducer